import { BsShop } from "react-icons/bs";
import { FaSuitcase, FaGraduationCap, FaUserTie, FaCommentDots, FaDesktop, FaCloud } from "react-icons/fa";

export default function DeliveredProjects() {
    return (
        <section className="bg-white py-12 px-6 text-center">
            <h2 className="text-3xl font-bold text-gray-800 mb-10">
                We’ve Worked & Delivered
            </h2>
            <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                {[
                    [<FaSuitcase size={40} />, "Custom ERP Solutions for Tourism & Travel"],
                    [<FaGraduationCap size={40} />, "Scalable ERP Platforms for Education"],
                    [<FaUserTie size={40} />, "Integrated HRM & Payroll Systems"],
                    [<FaCommentDots size={40} />, "Cross-Platform SMS Gateway (Web & Mobile)"],
                    [<FaDesktop size={40} />, "Accounting & Inventory Desktop Applications"],
                    [<FaCloud size={40} />, "SaaS & Multi-Tenant Cloud Platforms"],
                    [<BsShop size={40} />, "E-commerce Platforms & Marketplace Systems"],
                ].map(([icon, label], i) => (
                    <div
                        key={i}
                        className="bg-[#371865] text-white border border-gray-200 p-6 rounded-2xl shadow hover:shadow-md transition duration-300 flex flex-col items-center justify-center"
                    >
                        <div className="mb-3">{icon}</div>
                        <p className="text-white font-medium text-center">{label}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
